export default {
  GET_TOKEN: state => {
    return state.token;
  },
  IS_AUTHENTICATED: state => {
    return state.user.authenticated;
  },
  GET_ACTIVATED_PROJECT: state => {
    return state.activatedProject;
  },
  GET_ACCOUNT_DATA: state => {
    return state.login;
  },
  GET_SNACK_BAR: state => {
    return state.snackbar;
  },
  GET_LANG: state => {
    return state.lang;
  },
  PAGINATION: state => {
    return state.pagination;
  },
  PAGINATOR: state => {
    return state.paginator;
  },
  GET_PAYMENT_DETAIL_DATA: state => {
    return state.payment_progress_detail;
  },
  GET_UPLOAD_CONTRACT_LIST: state => {
    return state.file_upload_contract_data;
  },
  GET_UPLOAD_CASE_LIST: state => {
    return state.file_upload_case_data;
  },
  PAYMENT_PROGRESS_DATA: state => {
    return state.payment_progress;
  },
  GET_CONTRACT_DETAIL_DATA: state => {
    return state.contract_detail;
  },
  GET_CONTRACT_DATA: state => {
    return state.contract_data;
  },
  PAGE_SHOWING: state => {
    return state.pageShowing;
  },
  PAGE_ARROW: state => {
    return state.pageArrow;
  },
  GET_CUSTOMER_DATA: state => {
    return state.customers;
  },
  GET_CUSTOMER_DATA_REWARD_POINT: state => {
    return state.customer_give_reward_point;
  },
  GET_UPLOAD_USER_LIST: state => {
    return state.file_upload_user_data;
  },
  GET_USER_DATA: state => {
    return state.users;
  },
  GET_APARTMENT_FROM_ACCOUTINGHOMEBALANCE_DATA: state => {
    return state.apartmentcodefromaccounthomebalance;
  },
  GET_SERVICE_DATA: state => {
    return state.services;
  },
  SERVICE_DETAILS: state => {
    return state.serviceDetails;
  },
  UPDATE_SERVICE_DATA: state => {
    return state.serviceReturnData;
  },
  SERVICE_TYPE_LIST: state => {
    return state.serviceTypes;
  },
  SERVICE_HISTORY_DATA: state => {
    return state.serviceHistory;
  },
  SERVICE_ASSIGNED_DATA: state => {
    return state.serviceAssigned;
  },
  CUSTOMER_DETAIL_DATA: state => {
    return state.customerDetails;
  },
  USER_DETAIL_DATA: state => {
    return state.userDetails;
  },
  UPDATE_CUSTOMER_DATA: state => {
    return state.customerReturnData;
  },
  GET_PROJECT_TEMPLATE_USED_DATA: state => {
    return state.get_project_template_used;
  },
  GET_APARTMENT_LIST_DATA: state => {
    return state.apartments;
  },
  GET_APARTMENT_LIST_NO_PAGE_DATA: state => {
    return state.apartmentListNoPage;
  },
  GET_APARTMENT_REALESTATE_DATA: state => {
    return state.apartmentrealestate;
  },
  GET_APARTMENT_SCHEDULE_PROGRESS_DATA: state => {
    return state.apartmentscheduleprogress;
  },
  GET_LIST_EMAIL_HISTORY_AGENT_DATA: state => {
    return state.emailHistoruAgentListResult;
  },
  GET_AVAILABLE_APARTMENT_DATA: state => {
    return state.available_apartments;
  },
  GET_ADVERTISE_DATA_PROJECT_INFO_DATA: state => {
    return state.advertiseProjectInfo;
  },
  GET_USER_GUEST_DATA: state => {
    return state.userguest;
  },
  GET_USER_GUEST_DETAIL_DATA: state => {
    return state.userguestdetail;
  },
  CASE_LIST: state => {
    return state.cases;
  },
  GET_REWARD_POINT_DATA: state => {
    return state.reward_points;
  },
  VEHICLE_TYPE_LIST: state => {
    return state.vehicle_types;
  },
  GET_ADVERTISE_LIST: state => {
    return state.advertise;
  },
  GET_ADVERTISE_PROJECT_INFO_LIST: state => {
    return state.advertise;
  },
  GET_ADVERTISE_DETAIL_LIST: state => {
    return state.advertisedetail;
  },
  GET_ADVERTISE_PROJECT_INFO_DETAIL_LIST: state => {
    return state.advertiseprojectinfodetail;
  },
  GET_FLOOR_APARTMENT_DATA: state => {
    return state.floor_apartment;
  },
  VEHICLE_MANUFACTURER_LIST: state => {
    return state.vehicle_manufacturers;
  },
  VEHICLE_LIST: state => {
    return state.vehicles;
  },
  STAFF_LIST: state => {
    return state.staffs;
  },
  CARDS_LIST: state => {
    return state.cards;
  },
  RELATIVES_LIST: state => {
    return state.relatives;
  },
  ESCALATION_PROCESS_LIST: state => {
    return state.escalationProcesses;
  },
  ESCALATION_STAGE_LIST: state => {
    return state.escalationStages;
  },
  PROJECT_LIST: state => {
    return state.projects;
  },
  GET_PROJECT_MODULE_DATA: state => {
    return state.projectmodules;
  },
  GET_AVAILABLE_MODULE_DATA: state => {
    return state.available_module;
  },
  GET_CASE_DATA: state => {
    return state.caseDetails;
  },
  APARTMENT_DETAIL_DATA: state => {
    return state.apartmentDetails;
  },
  APARTMENT_REALESTATE_DETAIL_DATA: state => {
    return state.apartmentRealestateDetails;
  },
  APARTMENT_SCHEDULE_PROGRESS_DETAIL_DATA: state => {
    return state.apartmentScheduleProgressDetails;
  },
  GET_RESIDENT_DATA: state => {
    return state.residents;
  },
  RESIDENT_DETAIL_DATA: state => {
    return state.residentDetails;
  },
  GET_PROPERTY_DATA: state => {
    return state.propertys;
  },
  PROPERTY_DETAIL_DATA: state => {
    return state.propertyDetails;
  },
  GET_PROPERTY_TYPE_DATA: state => {
    return state.propertyTypes;
  },

  INVOICE_DETAIL_DATA: state => {
    return state.invoiceDetails;
  },
  GET_INVOICE_DATA: state => {
    return state.invoices;
  },
  GET_INVOICE_DATA_PERFORMANCE: state => {
    return state.invoices_list_performance;
  },
  GET_INVOICE_DATA_PERFORMANCE_VS2: state => {
    return state.invoices_list_performance_vs2;
  },
  GET_INVOICE_RECEIPT_DATA_PERFORMANCE: state => {
    return state.invoices_receipt_list_performance;
  },
  GET_FILTER_INVOICE_DATA: state => {
    return state.filterInvoices;
  },
  UPDATE_INVOICE_DATA: state => {
    return state.invoiceReturnData;
  },

  INVOICE_STATUS_DETAIL_DATA: state => {
    return state.invoiceStatusDetails;
  },
  GET_INVOICE_STATUS_DATA: state => {
    return state.invoiceStatus;
  },
  GET_CURRENT_USAGE_DATA: state => {
    return state.period_current;
  },
  UPDATE_INVOICE_STATUS_DATA: state => {
    return state.invoiceStatusReturnData;
  },
  SERVICE_RECORD_HISTORY_DATA: state => {
    return state.serviceRecordHistory;
  },

  // [TABLE]
  // [TABLE]_DETAIL_DATA
  // GET_[TABLE]_DATA
  // UPDATE_[TABLE]_DATA
  APARTMENT_MONTHLY_USAGE_DATA: state => {
    return state.apartmentMonthlyUsage;
  },
  //Todo List
  TODO_LIST_DATA: state => {
    return state.todoList;
  },
  //Asset
  GET_ASSET_DATA: state => {
    return state.assets;
  },
  ASSET_DETAIL_DATA: state => {
    return state.assetDetails;
  },
  GET_ASSET_TYPE_DATA: state => {
    return state.propertyTypes;
  },
  GET_REPORT_MONTHLY_USAGE_DATA: state => {
    return state.reportmonthlyusage;
  },
  GET_SERVICE_MONTHLY_USAGE_DATA: state => {
    return state.apartmentservicemonthlyusage;
  },
  GET_BULK_DATA_IMPORT_LIST: state => {
    return state.get_bulk_data_import;
  },
  GET_INVOICE_LIST_BY_SEARCH_TEMPLATE_DATA: state => {
    return state.invoiceListByTemplate;
  },
  GET_TEMPLATE_EMAIL_OB_DATA: state => {
    return state.templateemailobject;
  },
  GET_TEMPLATE_EMAIL_DATA: state => {
    return state.get_template_email_data;
  },
  GET_TEMPLATE_DETAIL_DATA: state => {
    return state.templateEmailDetailData;
  },
  GET_PROJECT_EMAIL_TEMPLATE_DATA: state => {
    return state.projectemailtemplate;
  },
  GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: state => {
    return state.customizetablepersonalconfig;
  },
  GET_MEMBERROLECODES_DATA: state => {
    return state.memberrolecodes;
  },
  GET_INVOICE_STATUS_FULL_DATA: state => {
    return state.invoice_status;
  },
  GET_CURRENT_ROLE: state => {
    return state.current_role;
  },
  GET_ALLMODULES_DATA: state => {
    return state.projectallmodules;
  },
  GET_ALL_MODULES_PROJECT_DATA: state => {
    return state.projectallmodules_new_project;
  },
  GET_ROLEPERMISSION_DATA: state => {
    return state.rolepermission;
  },
  GET_FUNCTIONS_DATA: state => {
    return state.functions;
  },
  GET_FUNCTIONPERMISSIONS_DATA: state => {
    return state.functionpermissions;
  },
  GET_APARTMENTPERMISSIONS_DATA: state => {
    return state.apartment_permissions;
  },
  COUNT_LIABILITIES_APARTMENT_MONTHLY_USAGE_DATA: state => {
    return state.apartment_monthly_usage_liabilities;
  },
  PROJECT_HISTORY_LIST: state => {
    return state.project_history_list;
  },
  GET_PROJECT_BANK_TRANSFER_DATA: state => {
    return state.project_bank_transfer;
  },
  GET_SEARCH_LIST_DATA: state => {
    return state.search_list;
  },
  GET_PROJECT_ALL_ALL_MODULE_DATA: state => {
    return state.project_all_all_module;
  },
  GET_RECEIPT_DATA: state => {
    return state.receipts;
  },
  GET_BATCH_JOB_LIST_DATA: state => {
    return state.batch_jobs;
  },
  GET_BATCH_JOB_DETAIL_DATA: state => {
    return state.batchJobDetails;
  },
  GET_BATCH_JOB_HISTORY_DATA: state => {
    return state.batch_jobs_history;
  },
  GET_LIST_AVAILABLE_BANKS_DATA: state => {
    return state.available_banks;
  },

  // =========================================================
  // MOBILE APPLICATION, OPERATION SYSTEM AND OS VERSION
  // =========================================================

  GET_MOBILE_APPLICATION_DATA: state => {
    return state.mobileApplications;
  },

  GET_MOBILE_OS_DATA: state => {
    return state.mobileOperationSystems;
  },

  GET_MOBILE_OS_VERSION_DATA: state => {
    return state.mobileOSVersion;
  },
  GET_REPAIR_LIST_DATA: state => {
    return state.repairList;
  },
  GET_STATISTICAL_EXPORT_INVOICE_DATA: state => {
    return state.statisticalExportInvoice;
  },
  GET_STATISTICAL_APARTMENT_PAYMENT_LATE_DATA: (state, payload) => {
    return state.statisticalApartmentPaymentLate;
  },
  COUPONS_LIST: state => {
    return state.coupons;
  },
  GET_APARTMENT_RESERVATION_LIST_DATA: (state, payload) => {
    return state.apartmentReservations;
  },
  GET_LEASEBACK_COMPANY_DATA: state => {
    return state.leaseback_company_list;
  },
  GET_BOOKING_DETAIL_DATA: state => {
    return state.bookingDetails;
  },
  GET_BOOKING_DETAIL_BY_BOOKING_CODE_DATA: state => {
    return state.bookingDetailsByBookingCode;
  },
  GET_ALL_BOOKING_BY_APARTMENT_DATA: state => {
    return state.allBookingByApartment;
  },
  GET_APARTMENT_CUSTOMER_INFORMATION_BOOKING_DETAIL_DATA: state => {
    return state.apartmentCustomerInfoBookingDetail;
  },
  GET_BOOKINGS_BY_APARTMENT_BEFORE_MOVING_DATA: state => {
    return state.bookingsByApartmentBeforeMoving;
  },
  GET_DOCUMENT_DATA: state => {
    return state.documents;
  },
  GET_DOCUMENT_DETAIL_DATA: state => {
    return state.documents;
  },
  GET_LAST_THIS_W_E_MONTH_VALUE_DATA: state => {
    return state.lastThisWEMonthValue;
  },
  GET_APARTMENT_LEASEBACK_CLIENTS_LIST_DATA: state => {
    return state.apartment_leaseback_clients;
  },
  DETAILED_REPORT_BY_EACH_MONTH_DATA: state => {
    return state.detailedReportByEachMonth;
  },
  DETAILED_REPORT_A_MONTH_DATA: state => {
    return state.detailedReportAMonth;
  },
  GET_EINVOICE_BKAV_DATA: state => {
    return state.einvoices;
  },
  BOOKING_PAYMENTS: state => {
    return state.bookingPayments;
  },
  GET_INVOICE_GENERAL_INVOICE_DATA: state => {
    return state.invoice_general_invoice_list;
  },
  GET_INVOICE_GENERAL_INVOICE_DETAIL: state => {
    return state.invoice_general_invoice_detail;
  },
  GET_GROUP_BOOKING_DETAIL_DATA: state => {
    return state.groupBookingDetails;
  },
  STATISTICS_HAS_BREAKFAST_RESIDENT_CLIENTS_DATA: state => {
    return state.statisticsHasBreakFastResidentClients;
  },
  GET_APARTMENT_CLEANING_SERVICE_DATA: state => {
    return state.cleaningService;
  },
  GET_APARTMENT_CLEANING_SERVICE_START_END_TIME_DATA: state => {
    return state.cleaningServiceStartEnd;
  },
  GET_MOBILE_NOTIFICATION_DATA: state => {
    return state.mobile_notification;
  },

  //smtp server
  GET_SMTP_PROJECT_DATA: state => {
    return state.get_smtp_project;
  },
  GET_CONFIG_SMTP_EMAIL_SERVER_DATA: state => {
    return state.get_config_smtp_email_server;
  },
  GET_SMTP_PROJECT_CONFIG_DATA: state => {
    return state.smtpProjectConfigList;
  },
  GET_SETTING_PROJECT_SMTP_DATA: state => {
    return state.settingProjectSMTP;
  },
  GET_SMTP_PROJECT_LIST_DATA: (state) => {
    return state.smtpProjectList
  },
  GET_BANNER_LIST_DATA: (state) => {
    return state.bannerList
  },
  GET_CATEGORY_NOTIFICATION_DATA: (state) => {
    return state.notificationCategory
  },
  GET_RESIDENTS_NEWS_LIST_DATA: (state) => {
    return state.newsResidentsList
  },
  GET_NEWS_LIST_DATA: (state) => {
    return state.newsList
  },
  GET_NEWS_CATEGORY_LIST_DATA: (state) => {
    return state.newsCategoriesList
  },
  // =======================================
  // Register export invoice
  // =======================================
  GET_REGISTER_EXPORT_INVOICE_LIST_DATA: (state) => {
    return state.registerExportInvoiceList
  },
  GET_REGISTER_EXPORT_INVOICE_LIST_NO_PAGE_DATA: (state) => {
    return state.registerExportInvoiceListNoPage
  },
  // =======================================
  // Feedback
  // =======================================
  GET_FEEDBACK_LIST_DATA: (state) => {
    return state.feedbackList
  },
  GET_FEEDBACK_CHAT_LIST_DATA: (state) => {
    return state.feedbackChatList
  },
  GET_FEEDBACK_DETAIL_HISTORY_LIST_DATA: (state) => {
    return state.feedbackDetailHistory
  },
  // =======================================
  // Department
  // =======================================
  GET_DEPARTMENT_LIST_DATA: (state) => {
    return state.departmentList
  },
  GET_DEPARTMENT_LIST_NO_PAGE_DATA: (state) => {
    return state.departmentListNoPage
  },
  // =======================================
  // Subject in department
  // =======================================
  GET_FEEDBACK_SUBJECT_LIST_DATA: (state) => {
    return state.subjectInDepartment
  },
  // =======================================
  // Get enable module and extra info
  // =======================================
  GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA: (state) => {
    return state.enableModuleAndExtraInfo
  },
  // =======================================
  // Apartment Type
  // =======================================
  GET_APARTMENT_TYPE_LIST_DATA: (state) => {
    return state.apartmentTypeList
  },
  GET_APARTMENT_TYPE_LIST_NO_PAGE_DATA: (state) => {
    return state.apartmentTypeListNoPage
  },
  // =======================================
  // Apartment Group
  // =======================================
  GET_APARTMENT_GROUP_LIST_DATA: (state) => {
    return state.apartmentGroupList
  },
  // =======================================
  // Apartment Image
  // =======================================
  GET_APARTMENT_IMG_LIST_DATA: (state) => {
    return state.apartmentImgList
  },
  GET_APARTMENT_MAP_IMG_LIST_DATA: (state) => {
    return state.apartmentMapImgList
  },
  GET_APARTMENT_CONTRACT_IMG_LIST_DATA: (state) => {
    return state.apartmentContractImgList
  },
  // =======================================
  // Product Unit
  // =======================================
  GET_PRODUCT_UNIT_LIST_DATA: (state) => {
    return state.productUnit
  },
  GET_PRODUCT_UNIT_LIST_NO_PAGE_DATA: (state) => {
    return state.productUnitNoPage
  },
  // =======================================
  // Product Group
  // =======================================
  GET_PRODUCT_GROUP_LIST_DATA: (state) => {
    return state.productGroup
  },
  GET_PRODUCT_GROUP_LIST_NO_PAGE_DATA: (state) => {
    return state.productGroupNoPage
  },
  // =======================================
  // Product
  // =======================================
  GET_PRODUCT_LIST_DATA: (state) => {
    return state.productList
  },
  GET_PRODUCT_LIST_NO_PAGE_DATA: (state) => {
    return state.productListNoPage
  },
  // =======================================
  // Service
  // =======================================
  GET_SERVICE_LIST_V2_DATA: (state) => {
    return state.serviceList
  },
  GET_SERVICE_LIST_V2_NO_PAGE_DATA: (state) => {
    return state.serviceListNoPage
  },
  GET_SERVICE_HISTORY_DATA: (state) => {
    return state.serviceHistoryList
  },
  // =======================================
  // Service group
  // =======================================
  GET_SERVICE_GROUP_LIST_DATA: (state) => {
    return state.serviceGroup
  },
  GET_SERVICE_GROUP_LIST_NO_PAGE_DATA: (state) => {
    return state.serviceGroupNoPage
  },
  // =======================================
  // Service unit
  // =======================================
  GET_SERVICE_UNIT_LIST_DATA: (state) => {
    return state.serviceUnit
  },
  GET_SERVICE_UNIT_LIST_NO_PAGE_DATA: (state) => {
    return state.serviceUnitNoPage
  },
  // =======================================
  // Service attribute
  // =======================================
  GET_SERVICE_ATTRIBUTE_LIST_DATA: (state) => {
    return state.serviceAttributeList
  },
  // =======================================
  // Product in apartment
  // =======================================
  GET_PRODUCT_IN_APARTMENT_LIST_DATA: (state) => {
    return state.productInApartment
  },
  // =======================================
  // Service in apartment
  // =======================================
  GET_SERVICE_IN_APARTMENT_LIST_DATA: (state) => {
    return state.serviceInApartment
  },
  // =======================================
  // Apartment in group
  // =======================================
  GET_APARTMENT_IN_GROUP_LIST_DATA: (state) => {
    return state.apartmentInGroup
  },
  GET_APARTMENT_IN_GROUP_WITH_GROUP_ID_LIST_DATA: (state) => {
    return state.apartmentInGroupWithId
  },
  // =======================================
  // Apartment booking
  // =======================================
  GET_APARTMENT_BOOKING_LIST_DATA: (state) => {
    return state.apartmentBookingList
  },
  GET_APARTMENT_BOOKING_DETAIL_DATA: (state) => {
    return state.apartmentBookingDetail
  },
  GET_APARTMENT_BOOKING_LIST_FOR_TIME_LINE_DATA: (state) => {
    return state.apartmentBookingListForTimeLine
  },
  GET_APARTMENT_LIST_IN_BOOKING_DATA: (state) => {
    return state.apartmentListInBooking
  },
  GET_USER_LIST_IN_BOOKING_DATA: (state) => {
    return state.userListInBooking
  },
  GET_USER_BOOKING_IN_APARTMENT_DATA: (state) => {
    return state.userBookingInApartment
  },
  // =======================================
  // Apartment type price
  // =======================================
  GET_APARTMENT_TYPE_PRICE_LIST_DATA: (state) => {
    return state.apartmentTypePriceList
  },
  // =======================================
  // Project extra info
  // =======================================
  GET_PROJECT_EXTRA_INFO_DATA: (state) => {
    return state.projectExtraInfo
  },
  // =======================================
  // Product in apartment type
  // =======================================
  GET_PRODUCT_IN_APARTMENT_TYPE_LIST_DATA: (state) => {
    return state.productInApartmentType
  },
  GET_PRODUCT_IN_APARTMENT_TYPE_LIST_NO_PAGE_DATA: (state) => {
    return state.productInApartmentTypeNoPage
  },
  // =======================================
  // Product and service used in apartment in booking
  // =======================================
  GET_PRODUCT_AND_SERVICE_USED_IN_APARTMENT_IN_BOOKING_DATA: (state) => {
    return state.productAndServiceUsedInApartmentInBooking
  },
  // =======================================
  // Service package
  // =======================================
  GET_SERVICE_PACKAGE_LIST_DATA: (state) => {
    return state.servicePackageList
  },
  GET_SERVICE_LIST_ENABLE_DATA: (state) => {
    return state.serviceListEnable
  },
  // =======================================
  // Management Service order
  // =======================================
  GET_NUMBER_SERVICE_ORDER_LIST_DATA: (state) => {
    return state.numberServiceOrderList
  },
  GET_SERVICE_ORDER_LIST_DATA: (state) => {
    return state.servicerOrderList
  },
  GET_SERVICE_ORDER_DETAIL_DATA: (state) => {
    return state.servicerOrderDetail
  },
  // =======================================
  // Apartment receipt
  // =======================================
  GET_APARTMENT_RECEIPT_INVOICE_REVENUE_LIST_DATA: (state) => {
    return state.invoiceRevenueList
  },
  // =======================================
  // Room Performance Report
  // =======================================
  GET_ROOM_PERFORMANCE_REPORT_DATA: (state) => {
    return state.roomPerformanceReportList
  },
  // =======================================
  // Position
  // =======================================
  GET_POSITION_LIST_DATA: (state) => {
    return state.positionList
  },
  // =======================================
  // User extra info
  // =======================================
  GET_USER_EXTRA_INFO_DATA: (state) => {
    return state.userExtraInfo
  },
  // =======================================
  // Event management
  // =======================================
  GET_EVENT_LIST_DATA: (state) => {
    return state.eventList
  },
  // =======================================
  // Config Email Group
  // =======================================
  GET_CONFIG_EMAIL_GROUP_DATA: (state) => {
    return state.configEmailGroupList
  },
  // =======================================
  // Config Revenue Code
  // =======================================
  GET_CONFIG_REVENUE_CODE_DATA: (state) => {
    return state.configRevenueCodeList
  },
  GET_MAINTENANCE_TYPE_LIST_DATA: (state) => {
    return state.maintenanceTypeList
  },
  GET_ASSET_LIST_DATA_V2: (state) => {
    return state.assetV2List
  },
  GET_ASSET_LIST_V2_NO_PAGE_DATA: (state) => {
    return state.assetV2ListNoPage
  },
  // =======================================
  // Maintenances
  // =======================================
  GET_MAINTENANCE_LIST_DATA: (state) => {
    return state.maintenanceList
  },
  GET_MAINTENANCE_LIST_NO_PAGE_DATA: (state) => {
    return state.maintenanceListNoPage
  },
  GET_ASSET_DETAIL_MAINTENANCE_HISTORY_LIST_DATA: (state) => {
    return state.assetMaintenanceHistoryList
  },
  GET_MAINTENANCE_DETAIL_DATA: (state) => {
    return state.maintenanceDetail
  },
  GET_MAINTENANCE_HISTORY_LIST_DATA: (state) => {
    return state.maintenanceHistoryList
  },
  GET_ACTIVITY_TRACKING_LIST_DATA: (state) => {
    return state.activityTrackingList
  },
  GET_ACTIVITY_PLAN_LIST_DATA: (state) => {
    return state.activityPlanList
  },
  // =======================================
  // External Link
  // =======================================
  GET_EXTERNAL_LINK_LIST_DATA: (state) => {
    return state.externalLinkList
  },
  // =======================================
  // Asset type
  // =======================================
  GET_ASSET_TYPE_LIST_DATA: (state) => {
    return state.assetTypes
  },
  // =======================================
  // Frequently Asked Questions
  // =======================================
  GET_FREQUENTLY_ASKED_QUESTIONS_LIST_DATA: (state) => {
    return state.frequentlyAskedQuestions
  },
  // =======================================
  // Incident
  // =======================================
  GET_INCIDENT_IN_FEEDBACK_LIST_DATA: (state) => {
    return state.incidentInFeedbackList
  },
  // =======================================
  // Asset Supplier
  // =======================================
  GET_ASSET_SUPPLIER_LIST_DATA: (state) => {
    return state.assetSupplierList
  },
  GET_ASSET_SUPPLIER_LIST_NO_PAGE_DATA: (state) => {
    return state.assetSupplierListNoPage
  },
  // =======================================
  // Approval Apartment Resident
  // =======================================
  GET_APPROVAL_APARTMENT_RESIDENT_LIST_DATA: (state) => {
    return state.approvalApartmentResidentList
  },
  GET_NUMBER_APPROVAL_APARTMENT_RESIDENT_DATA: (state) => {
    return state.numberApprovalApartmentResident
  },
  IS_SHOW_WELLCOME_MODAL: (state) => {
    return state.isShowWellcomeModal
  },
  GET_INVOICE_HISTORY_DATA: (state) => {
    return state.invoiceHistoryList
  },
  GET_NOTIFICATION_DATA: (state) => {
    return state.notificationList
  },
  GET_EMAIL_TEMPLATE_CATEGORY_DATA: (state) => {
    return state.emailTemplateCategory
  },
};



// WEBPACK FOOTER //
// ./src/store/getters.js